var forms = {

    settings: {
        required: $('form'),
        form_inputs: $('.gfield--type-email input, .gfield--type-phone input, .gfield--type-select select, .gfield--type-text input, .gfield--type-textarea textarea'),
    },

    init: function () {
        // General form functions
        if (this.settings.required.length) {
            forms.bindUIActions();
            forms.initializeLabels();
        }
    },

    bindUIActions: function () {
        // Activate rows on click
        this.settings.form_inputs.on('blur', forms.toggleLabels);
        this.settings.form_inputs.on('focus', forms.toggleLabels);
        this.settings.form_inputs.on('input', forms.toggleLabels);
    },

    // On page load activate labels that have a value in them
    initializeLabels: function () {
        this.settings.form_inputs.each(function () {
            if ($(this).val().length) {
                $(this).closest('.gfield').addClass('has-value');
            }
        });
    },

    // Toggle label positioning
    toggleLabels: function(e) {
        // Check for empty inputs and deactivate labels on blur
        if (e.type == 'blur') {
            $(this).closest('.gfield').removeClass('active');
            // If a value is present
            if ($(this).val().length) {
                $(this).closest('.gfield').addClass('has-value');
            } else {
                $(this).closest('.gfield').removeClass('has-value');
            }
        } else {
            $(this).closest('.gfield').addClass('active');
        }
    },

};
forms.init();
